import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./KnowledgeBase'),
  (m) => m.default
);
